import styled from "styled-components"

export const MockupWrapper = styled.div`
  min-height: 580px;
  margin-bottom: 6rem;

  .gatsby-image-wrapper {
    height: 580px;
    width: 296px;
    position: absolute;
    right: 0;
  }

  ${({ theme }) => theme.breakpoints.tablet} {
    .gatsby-image-wrapper {
      right: 10rem;
    }
  }

  ${({ theme }) => theme.breakpoints.smallDesktop} {
    min-height: initial;

    .gatsby-image-wrapper {
      width: 100%;
      height: auto;
      position: relative;
      right: auto;
    }
  }
`
